import { render, staticRenderFns } from "./ViewTextPost.vue?vue&type=template&id=63f25698&scoped=true"
import script from "./ViewTextPost.vue?vue&type=script&lang=js"
export * from "./ViewTextPost.vue?vue&type=script&lang=js"
import style0 from "./ViewTextPost.vue?vue&type=style&index=0&id=63f25698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f25698",
  null
  
)

export default component.exports